import { ONBOARD } from '~/consts'

export default {
  data() {
    return {
      loading_get_verification_code: false,
    }
  },

  methods: {
    async getVerificationCode(email, onboard = undefined) {
      if (this.loading_get_verification_code === true) {
        return;
      }

      this.loading_get_verification_code = true;
      try {
        const { data } = await this.$axios.post(ONBOARD.GET_VERIFICATION_CODE, {
          email: email,
          onboard
        });

        if (data.applicationSystem.code === 0) {
          toast.default(data.applicationSystem.message);
        } else {
          toast.danger(data.applicationSystem.message);
        }
      } catch (e) {}

      this.loading_get_verification_code = false;
    }
  }
}
